/* Quick-add desde las tarjetas de producto (home, colección, búsqueda, carruseles).
   Reutiliza el mismo mecanismo que el cart-drawer: añade con /cart/add.js pidiendo
   la sección 'cart-drawer', reemplaza su contenido y abre el drawer. Delegado en
   document para funcionar también con tarjetas inyectadas (carruseles, scroll infinito).
   No modifica el cart-drawer ni la estructura del enlace de la tarjeta. */
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

  function drawer() { return document.getElementById('cart-drawer'); }

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    if (typeof d.showModal === 'function') { if (!d.open) { try { d.showModal(); } catch (e) { d.setAttribute('open', ''); } } }
    else d.setAttribute('open', '');
  }

  function renderDrawer(html) {
    var d = drawer();
    if (!d || !html) return;
    var content = d.querySelector('[data-cart-drawer-content]');
    if (!content) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('[data-cart-drawer-root]');
    if (!fresh) return;
    content.innerHTML = '';
    content.appendChild(fresh);
    var count = parseInt(fresh.getAttribute('data-cart-items') || '0', 10);
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.classList.remove('hidden'); else el.classList.add('hidden');
    });
  }

  function fetchDrawerFallback() {
    return fetch(window.location.pathname + '?section_id=cart-drawer', { headers: { Accept: 'text/html' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) { if (html) renderDrawer(html); });
  }

  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'mdf-qa-toast';
    t.setAttribute('role', 'status');
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    setTimeout(function () {
      t.classList.remove('is-in');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 320);
    }, 2200);
  }

  function add(btn) {
    var id = btn.getAttribute('data-quick-add');
    if (!id || btn.hasAttribute('aria-busy')) return;
    btn.setAttribute('aria-busy', 'true');
    var label = btn.querySelector('[data-qa-label]');
    var original = label ? label.textContent : '';
    if (label) label.textContent = 'Añadiendo…';

    var body = new FormData();
    body.append('id', id);
    body.append('quantity', '1');
    body.append('sections', 'cart-drawer');
    body.append('sections_url', window.location.pathname);

    fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function (data) {
        if (data && data.sections && data.sections['cart-drawer']) {
          renderDrawer(data.sections['cart-drawer']);
          openDrawer();
        } else {
          return fetchDrawerFallback().then(openDrawer);
        }
      })
      .catch(function (err) {
        toast((err && err.description) ? err.description : 'No se pudo añadir el producto');
      })
      .finally(function () {
        btn.removeAttribute('aria-busy');
        if (label) label.textContent = original;
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-quick-add]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    add(btn);
  });
})();
